<template>
  <div class="row">
    <div class="col">
      <div class="d-flex justify-content-between mb-4">
        <div></div>
        <button v-if="!isView" class="bg-[#2463EB] text-[14px] font-normal text-white p-[10px] rounded-[8px]"
          type="button" @click="addOrderDetails">
          <i class="mdi mdi-plus text-white"></i>
          Add item
        </button>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table text-nowrap w-full">
        <thead class="bg-sky-50">
          <tr>
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
              #Item
            </th>
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
              Description
            </th>
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
              Quantity
            </th>
            <th v-if="showTotalColumn" class="text-[12px] leading-[18px] text-[#000000] font-semibold">
              Total
            </th>
            <th class="hidden md:block"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in items" :key="index">
            <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
              {{ index + 1 }}
            </td>
            <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
              {{
                item.product && item.product.name
                  ? item.product.name
                  : item.description
              }}
              <div class="mt-2.5" v-if="purchaseOrder.status === 'approved'">
                <p class="italic text-[12px] font-normal text-slate-500">
                  {{
                    justOpenQuantities[index] !== undefined
                      ? justOpenQuantities[index]
                      : "N/A"
                  }}
                  {{
                    item.product && item.product.name
                      ? item.product.name
                      : item.description
                  }}
                  left for delivery
                </p>
              </div>
            </td>
            <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
              {{ item.quantity }}
            </td>
            <td v-if="showTotalColumn" class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
              ₦
              <span class="font-semibold leading-[20px]">
                {{ formatMoney(getItemTotal(item)) }}</span>
            </td>
            <td>
              <p v-if="!isView" class="text-[#96A0B5] text-[14px] font-normal leading-[20px] cursor-pointer"
                @click.prevent="onEdit(item)">
                Edit
              </p>
            </td>
            <td>
              <RemoveItem v-if="!isView && items.length > 1" :item="item" @onRemove="onRemoveHandler" />
            </td>
          </tr>
          <tr v-if="!isView && showTotalColumn">
            <td></td>
            <td></td>
            <td>Total:</td>
            <td class="text-[14px] font-semibold leading-[20px] text-[#353535]">
              ₦{{ formatMoney(quotes && Object.keys(quotes).length > 0 ? quotes.totalAmount : subTotal) }}
            </td>
            <td></td>
          </tr>
          <tr v-if="isView && this.purchaseOrder.discountAmount != 0.00">
            <td></td>
            <td></td>
            <td>Discount:</td>
            <td class="text-[14px] font-semibold leading-[20px] text-[#353535]">
              ₦{{ formatMoney(purchaseOrder.discountAmount) }}
            </td>
            <td></td>
          </tr>
          <!-- <tr v-if="!isView && totalDiscount != 0.00">
            <td></td>
            <td></td>
            <td>Discount:</td>
            <td v-if="loader">Loading...</td>
            <td v-else class="text-[14px] font-semibold leading-[20px] text-[#353535]">
              ₦{{ formatMoney(totalDiscount) }}
            </td>
            <td></td>
          </tr> -->
          <tr v-if="isView">
            <td></td>
            <td></td>
            <td>Total:</td>
            <td class="text-[14px] font-semibold leading-[20px] text-[#353535]">
              ₦{{ formatMoney(totalAmount) }}
            </td>
            <td></td>
          </tr>
          <!-- <tr v-if="!isView">
            <td></td>
            <td></td>
            <td>Total:</td>
            <td class="text-[14px] font-semibold leading-[20px] text-[#353535]">
              ₦{{ formatMoney(totalAmount) }}
            </td>
            <td></td>
          </tr> -->
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import RemoveItem from "./ItemDetails/RemoveItemDetails";
import { helper } from "@/helper";
import { bus } from "../../main";

export default {
  name: "ManufacturerPurchaseOrderDetail",
  props: [
    "items",
    "isView",
    "purchaseOrder",
    "type",
    "justOpenQuantities",
    "quotes"
  ],
  components: {
    RemoveItem,
  },
  data() {
    return {
      loader: true,
    };
  },
  computed: {
    subTotal() {
      return this.items.reduce(
        (total, item) => {
          if (!item || !item.quantity) {
            return total;
          }
          return total + this.getItemTotal(item);
        },
        0
      );
    },
    totalAmount() {
      return this.subTotal - this.purchaseOrder.discountAmount;
    },
    showTotalColumn() {
      const hasNonZeroPrice = this.items.some(item =>
        item.price !== undefined &&
        Number(item.price) !== 0 &&
        Number(item.quantity) !== 0
      );
      return (hasNonZeroPrice && !(this.quotes && Object.keys(this.quotes).length > 0)) ||
        (this.quotes && Object.keys(this.quotes).length > 0 && this.quotes.totalAmount > 0);
    },

  },
  watch: {
    loader: {
      handler(newLoader) {
        bus.$emit('updateLoader', newLoader);
        this.$emit('updateLoader', newLoader);
      },
    },
    combinedItems: {
      handler() {
        if (this.isView) {
          this.loader = false;
          return;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.loader = false;
  },
  methods: {
    getItemTotal(item) {
      if (!item || !item.quantity) {
        return 0;
      }
      if (this.quotes && this.quotes.productPrices && this.quotes.productPrices.length > 0) {
        const productPrice = this.quotes.productPrices.find(
          priceInfo => priceInfo.productCode === item.productCode
        );
        if (productPrice) {
          return productPrice.totalAmount;
        }
      }
      if (item.price !== undefined) {
        return Number(item.price) * Number(item.quantity);
      }
      return 0;
    },
    addOrderDetails() {
      $("#mod-product-add").modal("show");
    },
    addItem() {
      $("#mod-apply-order-item").modal("show");
    },
    formatMoney(val) {
      const roundedVal = Math.round(val * 100) / 100;
      return helper.formatMoney(roundedVal);
    },
    onEdit(item) {
      if (!item) {
        return;
      }
      this.$emit("performEdit", {
        id: item.id,
        productId: item.id,
        quantity: item.quantity,
        productCode: item.productCode || "",
      });
    },
    onRemoveHandler(itemId) {
      this.$emit("onRemoveHandler", itemId);
    },
    removeItem(id) {
      this.$emit("onDeleteItem", id);
    },
    disabledSubmit() {
      if (this.loader) {
        return true;
      }
      return false;
    },
  },
};
</script>